const palettes = {
  brand: {
    primary: '#E31D93',
    primaryLight: '#FCE8F4',
    secondary: '#009686'
  },
  neutrals: {
    darkest: '#333',
    // darker: '#191919', // @TODO
    dark: '#5f5f5f',
    medium: '#999',
    light: '#E5E5E5',
    lighter: '#F7F7F7',
    lightest: '#FFF'
  },
  status: {
    alert: '#ff4d4f',
    alertLight: '#ffccc7',
    alertLighter: '#fff2f0',
    warning: '#faad14',
    warningLight: '#ffe58f',
    warningLighter: '#fffbe6',
    success: '#52c41a',
    successLight: '#b7eb8f',
    successLighter: '#f6ffed',
    info: '#1890ff',
    infoLight: '#91d5ff',
    infoLighter: '#e6f7ff',
    disabled: '#efefef'
  },
  energy: {
    A: '#02A044',
    A1: '#02A044',
    A2: '#02A044',
    A3: '#02A044',
    A4: '#02A044',
    B: '#24CE5D',
    C: '#9CE45A',
    D: '#F4E515',
    E: '#F1B523',
    F: '#E37727',
    G: '#D30606'
  }
};
export default palettes;
//# sourceMappingURL=palettes.js.map